// sources of data for laam.pk product cards
export const DataSourceEnum = Object.freeze({
	VALHALLA: 'valhalla',
	DIRECT: 'direct',
	STOREFRONT: 'storefront',
});

export const CARD_IMG_WIDTH = Object.freeze({
	OCTANE: 300,
	MARKETPLACE: 180,
});

export const DataSourceEnumMap = Object.freeze({
	storefront: 'sf',
	valhalla: 'v',
});

/* 
List of features that lead to product views & add to carts
This enum would be used for clicked_from field in firing events to statsig and cathode
clicked_from would be an array of strings e.g user clicks on quick-view via the syte search: 
clicked_from = ["search", "quick_view"]  & data_source = ["syte"]
*/
export const FeatureEnum = Object.freeze({
	BRAND_PAGE_CAROUSEL: 'brand_page_carousel',
	CHATBOT: 'chatbot',
	COLLECTION_LISTING: 'collection_listing',
	FLASH_SALE_CAROUSEL: 'flash_sale_carousel',
	HOMEPAGE_LISTING: 'homepage_listing',
	JUST_FOR_YOU_CAROUSEL: 'just_for_you_carousel',
	MORE_FROM_BRAND_CAROUSEL: 'more_from_brand_carousel',
	MORE_FROM_SAME_CATEGORY_CAROUSEL: 'more_from_same_category_carousel',
	MORE_FROM_THE_COLLECTION_CAROUSEL: 'more_from_the_collection_carousel',
	MORE_WITH_SIMILAR_DELIVERY_CAROUSEL: 'more_with_similar_delivery_carousel',
	MOST_LIKED_CAROUSEL: 'most_liked_carousel',
	MOST_LIKED_DISCOUNTED_CAROUSEL: 'most_liked_discounted_carousel',
	NEXT_PREV: 'next_prev',
	QUICK_VIEW: 'quick_view',
	SEARCH: 'search',
	SEARCH_BY_IMAGE: 'search_by_image',
	SIMILAR_PRODUCTS_CAROUSEL: 'similar_products_carousel',
	WISHLIST: 'wishlist',
	WISHLIST_CAROUSEL: 'wishlist_carousel',
	YOU_MAY_ALSO_LIKE_CAROUSEL: 'you_may_also_like_carousel',
});

/*
Mapping enum used for using short forms in query params for better visibility. Query params being used:
feat: FeatureEnumMap[FeatureEnum.KEY]
ver: valhalla version returned from products API (node-api)
*/
export const FeatureEnumMap = Object.freeze({
	brand_page_carousel: 'bpc',
	collection_listing: 'cl',
	flash_sale_carousel: 'fsc',
	homepage_listing: 'hl',
	just_for_you_carousel: 'jfc',
	more_from_same_category_carousel: 'mfscc',
	more_from_brand_carousel: 'mfbc',
	most_liked_discounted_carousel: 'moldc',
	most_liked_carousel: 'mlc',
	more_from_the_collection_carousel: 'mftcc',
	more_with_similar_delivery_carousel: 'mwsdc',
	np: 'next_prev',
	quick_view: 'qv',
	search: 's',
	search_by_image: 'sbi',
	similar_products_carousel: 'spc',
	wishlist: 'wl',
	wishlist_carousel: 'wl_c',
	you_may_also_like_carousel: 'ymalc',
});

export const COMPONENT_IDENTIFIERS = {
	HERO_BANNER: 'hero-banner',
	MINI_BANNER: 'mini-banner',
	VIDEO_BANNER: 'video-banner',
	PRODUCTS_CAROUSEL: 'products-carousel',
	PRODUCTS_GRID: 'products-grid',
	BRAND_CAROUSEL: 'brand-carousel',
	BRAND_GRID: 'brand-grid',
	ENTITY_CAROUSEL_SCROLLABLE: 'entity-carousel-scrollable',
	ENTITY_CAROUSEL: 'entity-carousel',
	ENTITY_GRID: 'entity-grid',
	ENTITY_X_PRODUCTS_CAROUSEL: 'entity-x-products-carousel',
	ENTITY_X_PRODUCTS_GRID: 'entity-x-products-grid',
	CATEGORY_GRID: 'category-grid',
	CATEGORY_CAROUSEL: 'category-carousel',
	CATEGORY_CAROUSEL_SCROLLABLE: 'category-carousel-scrollable',
	CATEGORY_GRID_SCROLLABLE: 'category-grid-scrollable',
	DROP_CAROUSEL: 'drop-carousel',
	DROP_GRID: 'drop-grid',
	DROP_X_PRODUCTS_CAROUSEL: 'drop-x-products-carousel',
	DROP_X_PRODUCTS_GRID: 'drop-x-products-grid',
	SUPER_CAROUSEL: 'super-carousel',
	IMAGE_WITH_TEXT: 'image-with-text',
} as const;

export type ComponentIdentifier =
	(typeof COMPONENT_IDENTIFIERS)[keyof typeof COMPONENT_IDENTIFIERS];
